import axios from 'axios';

export function getDaysForMonth(month, house_slug) {
    return axios.get('/api/days', {
        params: {
            month,
            house_slug,
        },
    })
        .then(response => {
            return response.data;
        })
    ;
}